// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__2vnUs","socialMedia":"Footer_socialMedia__qLdPA","socialIcon":"Footer_socialIcon__JOQak","socialImage":"Footer_socialImage__MWSLi"};